import React, { useRef, forwardRef, useImperativeHandle } from "react";
import SignatureCanvas from "react-signature-canvas";

export const SignaturePad = forwardRef((props, ref) => {
  const sigRef = useRef(null);

  const clear = () => {
    sigRef.current?.clear();
    if (props.onClear) {
      props.onClear();
    }
    if (props.onChange) {
      props.onChange(false);
    }
  };

  const save = () => {
    if (!sigRef.current || sigRef.current.isEmpty()) {
      return null;
    }

    const canvas =
      typeof sigRef.current.getTrimmedCanvas === "function"
        ? sigRef.current.getTrimmedCanvas()
        : sigRef.current.getCanvas();

    if (!canvas) {
      return null;
    }

    const image = canvas.toDataURL("image/png");
    if (props.onSave) {
      props.onSave(image);
    }
    if (props.onChange) {
      props.onChange(true);
    }
    return image;
  };

  useImperativeHandle(ref, () => ({
    clear,
    save,
    isEmpty: () => sigRef.current?.isEmpty() ?? true,
  }));

  return (
    <div>
      <SignatureCanvas
        ref={sigRef}
        penColor="black"
        canvasProps={{
          width: 400,
          height: 220,
          className: "border",
          style: {
            border: "2px solid #000",
            width: "100%",
            height: "220px",
            borderRadius: 4,
            backgroundColor: "#fff",
          },
        }}
        onEnd={() => {
          if (props.onChange) {
            props.onChange(!sigRef.current?.isEmpty());
          }
        }}
      />

      {props.showActions && (
        <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
          <button onClick={clear}>Clear</button>
          <button onClick={save}>Save</button>
        </div>
      )}
    </div>
  );
});

SignaturePad.displayName = "SignaturePad";